import { useCallback, useMemo } from 'react';
import { UserType } from 'api/models';
import { useAccountDataQuery } from 'queries/account';
export const useHideNonStrategicPartner = ()=>{
    const { data, isLoading } = useAccountDataQuery();
    const vendorCompany = useMemo(()=>data === null || data === void 0 ? void 0 : data.account.company, [
        data === null || data === void 0 ? void 0 : data.account.company
    ]);
    const isCurrentUserCustomer = useCallback(()=>(data === null || data === void 0 ? void 0 : data.userProfile.user.userType) === UserType.External, [
        data === null || data === void 0 ? void 0 : data.userProfile.user.userType
    ]);
    const isNonStrategicCompany = useCallback((company)=>company.strategic === false, []);
    const updateCompanyIfNonStrategic = useCallback((company)=>vendorCompany != null && isNonStrategicCompany(company) ? vendorCompany : company, [
        isNonStrategicCompany,
        vendorCompany
    ]);
    return {
        isDependentEntitiesLoading: isLoading,
        isCurrentUserCustomer,
        updateCompanyIfNonStrategic,
        isNonStrategicCompany
    };
};
